<div class="modal-container">
  <awc-input
    *ngIf="!this.data.requestBody && this.data.item"
    [label]="'Name export'"
    [(value)]="name"
  ></awc-input>

  <awf-dashboard-textarea label="Resource Description" [(value)]="description" (keydown)="stopProp($event)"></awf-dashboard-textarea>

  <div class="footer">
    <awc-button
      text="Confirm"
      [disabled]="sending"
      (buttonClicked)="confirmExport()"></awc-button>
  </div>
</div>
